import React from "react";
import { useTranslation } from "react-i18next";
import "../css/AppPage.css";
import "../utils/styles/PageAnimations.css";

function AppPage() {
  const { t } = useTranslation();

  return (
    <main className="app-page page-animated">
      <section className="app-page__hero">
        <h1 className="app-page__title animate-up delay-1">
          {t("appPage.title")}
        </h1>

        <div className="app-page__grid">
          {/* =================================================
              TEXT
             ================================================= */}
          <div className="app-page__content animate-left delay-2">
            <span className="app-page__eyebrow">oneNizer</span>

            <h2 className="app-page__feature-title">
              {t("appPage.featureTitle")}
            </h2>

            <p className="app-page__description">
              {t("appPage.featureDescription")}
            </p>

            <div className="app-page__features">
              <div className="app-page__feature">
                <span className="app-page__feature-icon">✓</span>

                <span>
                  {t("appPage.sharedLists", {
                    defaultValue: "Gemeinsame Listen",
                  })}
                </span>
              </div>

              <div className="app-page__feature">
                <span className="app-page__feature-icon">✓</span>

                <span>
                  {t("appPage.smartPlanning", {
                    defaultValue: "Smarte Planung",
                  })}
                </span>
              </div>

              <div className="app-page__feature">
                <span className="app-page__feature-icon">✓</span>

                <span>
                  {t("appPage.collaboration", {
                    defaultValue: "Gemeinsam organisieren",
                  })}
                </span>
              </div>

              <div className="app-page__feature">
                <span className="app-page__feature-icon">✓</span>

                <span>
                  {t("appPage.everythingOnePlace", {
                    defaultValue: "Alles an einem Ort",
                  })}
                </span>
              </div>
            </div>
          </div>

          {/* =================================================
              APP SHOWCASE
             ================================================= */}
          <div className="app-page__visual animate-right delay-3">
            <div className="app-page__visual-glow" />

            <img
              src="/images/screens/app-overview.png"
              alt="oneNizer App Funktionen im Überblick"
              className="app-page__showcase-image"
            />
          </div>
        </div>
      </section>
    </main>
  );
}

export default AppPage;
